import { render, staticRenderFns } from "./unqualifiedRegisterAction.vue?vue&type=template&id=2b986173&scoped=true"
import script from "./unqualifiedRegisterAction.vue?vue&type=script&lang=js"
export * from "./unqualifiedRegisterAction.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedRegisterAction.vue?vue&type=style&index=0&id=2b986173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b986173",
  null
  
)

export default component.exports